import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function getLevelColor(nivel) {
    switch (nivel?.toLowerCase()) {
        case 'destacado':
            return 'level-destacado';
        case 'competente':
            return 'level-competente';
        case 'básico':
        case 'basico':
            return 'level-basico';
        case 'insuficiente':
            return 'level-insuficiente';
        default:
            return 'level-sin-evaluar';
    }
}

export function getLevelBgColor(nivel) {
    switch (nivel?.toLowerCase()) {
        case 'destacado':
            return 'bg-indigo-500';
        case 'competente':
            return 'bg-emerald-500';
        case 'básico':
        case 'basico':
            return 'bg-amber-500';
        case 'insuficiente':
            return 'bg-rose-500';
        default:
            return 'bg-slate-300';
    }
}

export function formatDate(dateString) {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        return new Intl.DateTimeFormat('es-CL', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);
    } catch (_) {
        // Defensa contra fechas corruptas en BD: nunca romper la UI por una fecha mal guardada.
        return '';
    }
}

export function formatDateShort(dateString) {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        return new Intl.DateTimeFormat('es-CL', {
            day: '2-digit',
            month: 'short',
        }).format(date);
    } catch (_) {
        return '';
    }
}

export function downloadFile(content, filename) {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export const MODULOS = [
    {
        id: 'modulo-1',
        nombre: 'Módulo 1',
        titulo: 'Planificación, evaluación y reflexión',
        estado: 'activo',
        tareas: [
            {
                id: 'tarea-1',
                nombre: 'Tarea 1',
                titulo: 'Planificación de la enseñanza para todos y todas los/as estudiantes',
                indicadores: [
                    {
                        id: 'indicador-1-1',
                        nombre: 'Formulación de objetivos de aprendizaje',
                        descripcion: 'Este indicador evalúa la capacidad de el/la docente para plantear objetivos de aprendizaje que indican claramente las habilidades y conocimientos que sus estudiantes deben desarrollar.',
                    },
                    {
                        id: 'indicador-1-2',
                        nombre: 'Relación entre actividades y objetivos',
                        descripcion: 'Este indicador evalúa la capacidad de el/la docente para proponer actividades coherentes con los objetivos de aprendizaje.',
                    },
                    {
                        id: 'indicador-1-3',
                        nombre: 'Fundamentación de la planificación de una experiencia de aprendizaje',
                        descripcion: 'Este indicador evalúa la capacidad de el/la docente para fundamentar la pertinencia de las estrategias de enseñanza con la diversidad de su grupo, considerando distintos tipos de características de los/as estudiantes y los aprendizajes propuestos.',
                    },
                ],
            },
            {
                id: 'tarea-2',
                nombre: 'Tarea 2',
                titulo: 'Evaluación y uso de la información para el aprendizaje',
                indicadores: [
                    {
                        id: 'indicador-2-1',
                        nombre: 'Estrategia de monitoreo de los aprendizajes',
                        descripcion: 'Este indicador evalúa la capacidad de el/la docente para plantear indicadores de evaluación que señalan el desempeño esperado e implementar una actividad coherente con esos indicadores, con el fin de monitorear el progreso de los/as estudiantes en los aprendizajes.',
                    },
                    {
                        id: 'indicador-2-2',
                        nombre: 'Análisis a partir del monitoreo de los aprendizajes',
                        descripcion: 'Este indicador evalúa la capacidad de el/la docente para analizar e interpretar la información recogida a través de las estrategias de monitoreo, identificando sus causas y estableciendo conclusiones relevantes para su trabajo pedagógico.',
                    },
                    {
                        id: 'indicador-2-3',
                        nombre: 'Uso formativo de la información recogida a partir del monitoreo',
                        descripcion: 'Este indicador evalúa la capacidad de el/la docente para ajustar o plantear estrategias orientadas a la mejora de los aprendizajes de sus estudiantes, a partir de la información recogida durante el monitoreo de los aprendizajes.',
                    },
                ],
            },
            {
                id: 'tarea-3',
                nombre: 'Tarea 3',
                titulo: 'Reflexión en torno al desarrollo de aprendizajes socioemocionales',
                indicadores: [
                    {
                        id: 'indicador-3-1',
                        nombre: 'Reflexión en torno al desarrollo de aprendizajes socioemocionales',
                        descripcion: 'Este indicador evalúa la capacidad de el/la docente para:\n\u2022 Reconocer el aprendizaje socioemocional que sus estudiantes necesitan desarrollar a partir de la observación de ellos/as en situaciones de la vida escolar.\n\u2022 Reflexionar sobre cómo sus actitudes, formas de actuar y de relacionarse con sus estudiantes favorece o dificulta promover el desarrollo de aprendizajes socioemocionales en ellos/as.',
                    },
                ],
            },
        ],
    },
    {
        id: 'modulo-2',
        nombre: 'Módulo 2',
        titulo: 'Clase grabada',
        estado: 'activo',
        tareas: [
            {
                id: 'tarea-4',
                nombre: 'Tarea 4',
                titulo: 'Ambiente y participación en el aula',
                indicadores: [
                    { id: 'indicador-m2-9', nombre: 'Ambiente para el aprendizaje', descripcion: 'Evalúa el clima de aula que genera el docente: respeto, confianza, interacción genuina y participación espontánea de los estudiantes.' },
                    { id: 'indicador-m2-10', nombre: 'Promoción de la participación y colaboración', descripcion: 'Evalúa si el docente promueve la participación activa, la colaboración entre pares y la co-construcción del aprendizaje de forma sistemática.' },
                ],
            },
            {
                id: 'tarea-5',
                nombre: 'Tarea 5',
                titulo: 'Enseñanza y aprendizaje profundo',
                indicadores: [
                    { id: 'indicador-m2-11', nombre: 'Contribución de los períodos de la jornada a los objetivos', descripcion: 'Evalúa la coherencia entre los objetivos, las actividades y el uso del tiempo pedagógico durante la clase.' },
                    { id: 'indicador-m2-12', nombre: 'Promoción de habilidades para aprendizaje profundo', descripcion: 'Evalúa si el docente promueve análisis, argumentación, metacognición y pensamiento crítico en sus estudiantes.' },
                ],
            },
            {
                id: 'tarea-6',
                nombre: 'Tarea 6',
                titulo: 'Experiencias, retroalimentación y equidad',
                indicadores: [
                    { id: 'indicador-m2-13', nombre: 'Uso de conocimientos y experiencias de estudiantes', descripcion: 'Evalúa si el docente activa y usa sistemáticamente los conocimientos previos, intereses y experiencias de sus estudiantes.' },
                    { id: 'indicador-m2-14', nombre: 'Retroalimentación: uso de desempeños para el aprendizaje', descripcion: 'Evalúa si el docente usa los desempeños de los estudiantes para promover metacognición, reflexión y mejora del aprendizaje.' },
                    { id: 'indicador-m2-15', nombre: 'Equidad de género', descripcion: 'Evalúa si el docente promueve reflexión crítica sobre estereotipos de género y forma pensamiento ciudadano.' },
                ],
            },
        ],
    },
    {
        id: 'modulo-3',
        nombre: 'Módulo 3',
        titulo: 'Trabajo colaborativo para el desarrollo profesional',
        estado: 'activo',
        tareas: [
            {
                id: 'tarea-m3-5',
                nombre: 'Tarea 5',
                titulo: 'Trabajo colaborativo para el desarrollo profesional',
                indicadores: [
                    { id: 'indicador-m3-16', nombre: 'Relevancia del problema a partir del análisis de evidencia', descripcion: 'Evalúa la capacidad de el/la docente para comprender la relevancia que tiene abordar problemas para el proceso de enseñanza y aprendizaje de los/las estudiantes y fundamentarlo en el análisis de evidencias.' },
                    { id: 'indicador-m3-18', nombre: 'Diálogo pedagógico en torno a la implementación del trabajo colaborativo', descripcion: 'Evalúa la capacidad de reflexionar con otros/as integrantes de la comunidad educativa o redes a través del diálogo, estableciendo relaciones entre el aprendizaje de los/as estudiantes y la práctica de enseñanza, para tomar decisiones fundadas en un conocimiento construido en conjunto.' },
                    { id: 'indicador-m3-23', nombre: 'Evaluación conjunta de la forma de trabajar en la experiencia colaborativa', descripcion: 'Evalúa la capacidad de evaluar de manera crítica la forma de trabajo desarrollada durante la experiencia colaborativa, identificando aspectos que facilitaron y obstaculizaron la consecución de los objetivos del trabajo colaborativo para reconocer lo que es valioso de aplicar en futuras implementaciones.' },
                    { id: 'indicador-m3-21', nombre: 'Aprendizajes profesionales a partir de la experiencia de trabajo colaborativo', descripcion: 'Evalúa la capacidad de el/la docente para evaluar el aprendizaje profesional que logró a partir del trabajo colaborativo, considerando cómo se han modificado sus conocimientos o habilidades y cómo ello se ha manifestado en su práctica y en el aprendizaje de sus estudiantes.' },
                ],
            },
        ],
    },
];

// Flat TAREAS list for backward compatibility
export const TAREAS = MODULOS.flatMap((m) =>
    m.tareas.map((t) => ({
        id: t.id,
        nombre: t.nombre,
        titulo: t.titulo,
        descripcion: t.titulo,
        modulo: m.id,
        indicadores: t.indicadores,
    }))
);

export const NIVELES = ['Diferencial', 'Educación Parvularia', 'Educación Básica', 'Educación Media'];

export const TIPOS_ESTABLECIMIENTO = [
    'Municipal',
    'Particular Subvencionado',
    'Particular Pagado',
    'Administración Delegada',
];

export const REGIONES_CHILE = [
    'Arica y Parinacota',
    'Tarapacá',
    'Antofagasta',
    'Atacama',
    'Coquimbo',
    'Valparaíso',
    'Metropolitana',
    'O\'Higgins',
    'Maule',
    'Ñuble',
    'Biobío',
    'La Araucanía',
    'Los Ríos',
    'Los Lagos',
    'Aysén',
    'Magallanes',
];

export const NIVELES_EVALUACION = ['Insuficiente', 'Básico', 'Competente', 'Destacado'];
